import React from 'react';
import { showCornerStone } from '@benzinga/navigation-ui';
import { MoneyTemplateProps } from '../../entities';
import { FloatingPopup } from '../Campaign/FloatingPopup';
import { Popup } from '../Popup';
import { CampaignPopup } from '../Campaign/CampaignPopup';
import { MoneyPostLayout } from '../MoneyPostLayout';
import classNames from 'classnames';
import { useBenzingaEdge } from '@benzinga/edge';
import { appEnvironment, appName } from '@benzinga/utils';
import { PortfolioHeader } from '../EdgePortfolioTemplatePart/PortfolioHeader';
import { CmsStyles } from './CmsStyles';
import styles from './EdgePortfolioTemplate.module.css';

export const EdgePortfolioTemplate: React.FC<MoneyTemplateProps> = ({
  layoutAboveArticle,
  layoutBelowArticle,
  layoutMainClassName,
  post,
  sidebarSettings,
}) => {
  const layout = showCornerStone(post ?? null) ? 'wide' : 'narrow';
  const hasAdLight = useBenzingaEdge().adLightEnabled;
  const isMoneyApp = appEnvironment().isApp(appName.money);

  return (
    <div className={classNames(styles.wrapper, 'font-manrope', { [layout]: !!layout })}>
      {post && <PortfolioHeader post={post} />}
      <MoneyPostLayout
        layoutAboveArticle={layoutAboveArticle}
        layoutBelowArticle={layoutBelowArticle}
        layoutMainClassName={layoutMainClassName}
        maxWidth={layout === 'wide' ? '1400px' : '1100px'}
        post={post ?? null}
        sidebarSettings={sidebarSettings}
        wrapperClassName={styles.moneyPostLayoutWrapper}
      />
      {post?.campaigns && <FloatingPopup targets={post.campaigns} />}
      {post?.campaigns && (isMoneyApp || !hasAdLight) && <CampaignPopup targets={post.campaigns} />}
      {post?.unmonetized_interstitial && <Popup interstitial={true} popup={post.unmonetized_interstitial} />}
      <CmsStyles styles={post?.styles} />
    </div>
  );
};

export default EdgePortfolioTemplate;
